module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cross-white-4b3d326815674f7c7dd2e1d86623eadb.svg";